/* eslint-disable indent */
import React from 'react'
import { Card } from 'react-bootstrap'
import { taidot, translations } from '../services/arrays'
import { isOverMonthOld } from '../services/helpfunctions'
import { getTranslation } from '../services/translations'

const TrainingParamsCard = ({ player, language, lang }) => {
  const t = key => getTranslation(lang, key)
  const playerIsOverMonthOld = isOverMonthOld(player.dateUpdated)

  return (
    <Card
      className="w-100"
      style={{
        backgroundColor: '#23272A',
        color: '#FFFFFF',
        borderColor: '#1E2124',
        fontSize: '0.85rem',
      }}
    >
      <Card.Header
        style={{
          backgroundColor: '#1a1d21',
          color: '#FFFFFF',
          fontSize: '0.8rem',
          padding: '6px 12px',
        }}
      >
        {t('trainingInfo')}
      </Card.Header>
      <Card.Body style={{ padding: '8px 12px' }}>
        {player.trainingData && !playerIsOverMonthOld ? (
          Object.entries(player.trainingData).map(([key, value], index) => {
            // Suodatetaan pois "minutes" ja "effency" kentät
            if (key === 'minutes' || key === 'effency') {
              return null
            }

            // Käsitellään "mode" kenttä erityisesti
            const modeIndex = Number(value) - 2
            const displayValue =
              key === 'mode'
                ? modeIndex >= 0 && modeIndex < taidot.length
                  ? taidot[modeIndex]
                  : value
                : value

            // Tarkista että käännös on olemassa
            if (!translations[key]) {
              return null
            }

            return (
              <div key={index} style={{ marginBottom: '2px' }}>
                {translations[key][language]}: {displayValue}
              </div>
            )
          })
        ) : (
          <div style={{ color: '#888', fontSize: '0.8rem' }}>
            {t('noAccessToPlayer') || '-'}
          </div>
        )}
      </Card.Body>
    </Card>
  )
}

export default TrainingParamsCard
